/**
 * Rellena el segmento "colección" en breadcrumbs PDP cuando Shopify no expone `collection`
 * (p. ej. URL /products/...). Usa sessionStorage guardado en páginas de colección, o referrer.
 */
const STORAGE_KEY = 'onne_last_collection';

function humanizeHandle(handle) {
  if (!handle) return '';
  return handle
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/**
 * ONNE 17/09/2026: titulos de las colecciones del producto EN EL IDIOMA ACTUAL,
 * impresos por blocks/pdp-breadcrumbs.liquid. Permite pintar el nombre correcto
 * aunque lo guardado en sessionStorage venga de otro idioma.
 */
function getCollectionTitles(root) {
  try {
    const el = root.querySelector('script[data-pdp-breadcrumbs-collections]');
    return el ? JSON.parse(el.textContent) : {};
  } catch {
    return {};
  }
}

/** Raiz del idioma actual: '' en el primario, '/es' '/it'... en el resto. */
function localeBase(root) {
  const r = root.dataset.rootUrl || '/';
  return r === '/' ? '' : r.replace(/\/$/, '');
}

/** Extrae el handle de coleccion de cualquier ruta, lleve o no prefijo de idioma. */
function collectionHandleFrom(pathname) {
  const m = String(pathname || '').match(/\/collections\/([^/?#]+)/);
  return m ? m[1] : '';
}

function syncSeparators(root, middleLi) {
  const sepAfterHome = root.querySelector('[data-pdp-breadcrumbs-sep-after-home]');
  const sepBeforeCurrent = root.querySelector('[data-pdp-breadcrumbs-sep-before-current]');
  const currentLi = root.querySelector('[data-pdp-breadcrumbs-current]');
  const middleHasLink =
    middleLi && !middleLi.hidden && middleLi.querySelector('a[data-pdp-breadcrumbs-collection-link], a.pdp-breadcrumbs__link');
  const hasCurrent = Boolean(currentLi && !currentLi.hidden);

  if (sepAfterHome) {
    sepAfterHome.hidden = !(middleHasLink || hasCurrent);
  }
  if (sepBeforeCurrent) {
    sepBeforeCurrent.hidden = !middleHasLink || !hasCurrent;
  }
}

function initNav(root) {
  const middleLi = root.querySelector('[data-pdp-breadcrumbs-middle]');
  const sepBeforeCurrent = root.querySelector('[data-pdp-breadcrumbs-sep-before-current]');
  if (!middleLi) return;

  const hasLiquid = middleLi.querySelector('a[data-pdp-breadcrumbs-collection-link]');
  if (hasLiquid) {
    if (sepBeforeCurrent) sepBeforeCurrent.hidden = false;
    syncSeparators(root, middleLi);
    return;
  }

  let url = '';
  let title = '';

  const titles = getCollectionTitles(root);
  const base = localeBase(root);

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const d = JSON.parse(raw);
      if (d && (d.handle || typeof d.url === 'string')) {
        // El handle manda: la url guardada lleva el prefijo del idioma en que se visito
        // la coleccion, y usarla tal cual expulsa a la clienta a ese otro idioma.
        const handle = d.handle || collectionHandleFrom(d.url);
        if (handle) {
          url = base + '/collections/' + handle;
          title = titles[handle] || (d.title ? String(d.title) : '');
        }
      }
    }
  } catch {
    /* ignore */
  }

  if (!url && root.dataset.referrerFallback === 'true') {
    try {
      const ref = document.referrer ? new URL(document.referrer) : null;
      if (
        ref &&
        ref.origin === location.origin &&
        /\/collections\//.test(ref.pathname) &&
        !/\/products\//.test(ref.pathname)
      ) {
        const handle = collectionHandleFrom(ref.pathname);
        if (handle) {
          url = base + '/collections/' + handle;
          title = titles[handle] || humanizeHandle(handle);
        }
      }
    } catch {
      /* ignore */
    }
  }

  if (!url && root.dataset.fallbackCatalogUrl) {
    url = root.dataset.fallbackCatalogUrl;
    title = root.dataset.fallbackCatalogLabel || '';
  }

  if (url && title) {
    const a = document.createElement('a');
    a.className = 'pdp-breadcrumbs__link';
    a.href = url;
    a.textContent = title;
    middleLi.textContent = '';
    middleLi.appendChild(a);
    middleLi.hidden = false;
    if (sepBeforeCurrent) sepBeforeCurrent.hidden = false;
  } else {
    middleLi.innerHTML = '';
    middleLi.hidden = true;
    if (sepBeforeCurrent) sepBeforeCurrent.hidden = true;
  }

  syncSeparators(root, middleLi);
}

function run() {
  document.querySelectorAll('[data-pdp-breadcrumbs]').forEach(initNav);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run, { once: true });
} else {
  run();
}
